import { DPoP } from 'oidc-spa/DPoP';
import { oidcEarlyInit } from 'oidc-spa/entrypoint';

/**
 * Must run before Angular and the rest of the application are loaded.
 * DPoP only upgrades access tokens registered by oidc-spa; legacy bearer
 * tokens are left untouched.
 * `applicationBaseUrl` is the application's routing root, which may differ
 * from the document base used to load static assets.
 */
export function initializeOidcEarly(applicationBaseUrl?: string): boolean {
  if (typeof document === 'undefined') {
    return true;
  }

  return oidcEarlyInit({
    BASE_URL: applicationBaseUrl ?? new URL(document.baseURI).pathname,
    securityDefenses: {
      ...DPoP({ mode: 'auto' }),
    },
  }).shouldLoadApp;
}
